export default "__VITE_ASSET__0e826a8d__"